// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://explorer.zksync.io/address/0x11353117EB9cd5179Bb7F54BB22d8274dc4f1db7
export const USD1__USD = '0x11353117EB9cd5179Bb7F54BB22d8274dc4f1db7';

// https://explorer.zksync.io/address/0x2CfAb79113c81ebD672bC77c5B88Fc803b64cA77
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Level =
  '0x2CfAb79113c81ebD672bC77c5B88Fc803b64cA77';

// https://explorer.zksync.io/address/0x600E54Fc4cF6148Cd6696A3D37F5f672829BF7C2
export const ezETH__ETH = '0x600E54Fc4cF6148Cd6696A3D37F5f672829BF7C2';

// https://explorer.zksync.io/address/0x6E2Eb2F1E5d31Db83B6982a3E753F8615565fD1f
export const PCE_Price_Index_Percent_Change_Annual_Rate =
  '0x6E2Eb2F1E5d31Db83B6982a3E753F8615565fD1f';

// https://explorer.zksync.io/address/0xC7Bd1Ea3ec9D08C3068a63b7bd39799061bbb787
export const Real_GDP_Percent_Change_Annual_Rate = '0xC7Bd1Ea3ec9D08C3068a63b7bd39799061bbb787';

// https://explorer.zksync.io/address/0x7a6333CaC589e9B11b1fEC190a5828272A2893B5
export const PEPE__USD = '0x7a6333CaC589e9B11b1fEC190a5828272A2893B5';

// https://explorer.zksync.io/address/0x0E6AC8B967393dcD3D36677c126976157F993940
export const L2_Sequencer_Uptime_Status_Feed = '0x0E6AC8B967393dcD3D36677c126976157F993940';

// https://explorer.zksync.io/address/0x1b5a683579f53b9E30B538F70544444389633c75
export const LINK__USD = '0x1b5a683579f53b9E30B538F70544444389633c75';

// https://explorer.zksync.io/address/0x78F211E6707463F5b2254DE667b9A70a95d816b5
export const wrsETH_ETH_Exchange_Rate__ETH = '0x78F211E6707463F5b2254DE667b9A70a95d816b5';

// https://explorer.zksync.io/address/0xB66325FC0F8aA6dE6FeDFF4e51e54025cEea51eE
export const LINK__ETH = '0xB66325FC0F8aA6dE6FeDFF4e51e54025cEea51eE';

// https://explorer.zksync.io/address/0x2137c69DCb41f611Cc8f39F8A98047e774d6ED74
export const AAVE__USD = '0x2137c69DCb41f611Cc8f39F8A98047e774d6ED74';

// https://explorer.zksync.io/address/0x7e161604Da57DF30bbC9f0C166e8163fB9147a7a
export const xSolvBTC_NAV = '0x7e161604Da57DF30bbC9f0C166e8163fB9147a7a';

// https://explorer.zksync.io/address/0x8D3184a992f93729b249407C33F1e78abE0d650e
export const weETH__eETH_Exchange_Rate = '0x8D3184a992f93729b249407C33F1e78abE0d650e';

// https://explorer.zksync.io/address/0x97920183c36B022B46D6C14b9dA36c5f31A98C6A
export const sUSDe__USDe_Exchange_Rate = '0x97920183c36B022B46D6C14b9dA36c5f31A98C6A';

// https://explorer.zksync.io/address/0x1824D297C6d6D311A204495277B63e943C2D376E
export const USDC__USD = '0x1824D297C6d6D311A204495277B63e943C2D376E';

// https://explorer.zksync.io/address/0x43b29AF5d5527ebe35c4788810D11BdbA9205669
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Percent_Change_Annual_Rate =
  '0x43b29AF5d5527ebe35c4788810D11BdbA9205669';

// https://explorer.zksync.io/address/0x93A08A9D592101938D4a63c86d0989d7018c00D9
export const UNI__USD = '0x93A08A9D592101938D4a63c86d0989d7018c00D9';

// https://explorer.zksync.io/address/0x24a0C9404101A8d7497676BE12F10aEa356bAC28
export const wstETH_stETH_Exchange_Rate = '0x24a0C9404101A8d7497676BE12F10aEa356bAC28';

// https://explorer.zksync.io/address/0x92c2ed09B096470DF40973231Dac5aC987F9b8F9
export const rswETH__ETH_Exchange_Rate = '0x92c2ed09B096470DF40973231Dac5aC987F9b8F9';

// https://explorer.zksync.io/address/0x20Af81052722DbE38792e595De231C41F4D3255B
export const MELANIA__USD = '0x20Af81052722DbE38792e595De231C41F4D3255B';

// https://explorer.zksync.io/address/0x5d336664b5D7A332Cd256Bf68CbF2270C6202fc6
export const DAI__USD = '0x5d336664b5D7A332Cd256Bf68CbF2270C6202fc6';

// https://explorer.zksync.io/address/0x372A10990183E99FB29D4905b71f807ca5474827
export const Real_GDP_Level = '0x372A10990183E99FB29D4905b71f807ca5474827';

// https://explorer.zksync.io/address/0x2cC24D99500a134ea7f78736b5C329C84599fb1B
export const DOGE__USD = '0x2cC24D99500a134ea7f78736b5C329C84599fb1B';

// https://explorer.zksync.io/address/0x6D41d1dc818112880b40e26BD6FD347E41008eDA
export const ETH__USD = '0x6D41d1dc818112880b40e26BD6FD347E41008eDA';

// https://explorer.zksync.io/address/0x4899faF0b6c36620168D00e3DbD4CB9361244c4d
export const USDe__USD = '0x4899faF0b6c36620168D00e3DbD4CB9361244c4d';

// https://explorer.zksync.io/address/0xC406104c42211abd1A2cD411DDd071511515bDdd
export const Fidelity_USD_NAV = '0xC406104c42211abd1A2cD411DDd071511515bDdd';

// https://explorer.zksync.io/address/0xFc325A8E212319855906C9d02d7795C06baa5fBD
export const PCE_Price_Index_Level = '0xFc325A8E212319855906C9d02d7795C06baa5fBD';

// https://explorer.zksync.io/address/0x4Cba285c15e3B540C474A114a7b135193e4f1EA6
export const BTC__USD = '0x4Cba285c15e3B540C474A114a7b135193e4f1EA6';

// https://explorer.zksync.io/address/0xD1ce60dc8AE060DDD17cA8716C96f193bC88DD13
export const ZK__USD = '0xD1ce60dc8AE060DDD17cA8716C96f193bC88DD13';

// https://explorer.zksync.io/address/0x960eA047617cfB29AFcf2Ef6794C76713ff0C20C
export const TRUMP__USD = '0x960eA047617cfB29AFcf2Ef6794C76713ff0C20C';

// https://explorer.zksync.io/address/0xB615075979AE1836B476F651f1eB79f0Cd3956a9
export const USDT__USD = '0xB615075979AE1836B476F651f1eB79f0Cd3956a9';

// https://explorer.zksync.io/address/0x7024c64Ad30Ebf224e417CfDE4438606d2b9B690
export const rsETH__ETH_Exchange_Rate = '0x7024c64Ad30Ebf224e417CfDE4438606d2b9B690';

// https://explorer.zksync.io/address/0x498232F0a52D4e94A6e0Ea93D63C07Bc63133009
export const SOL__USD = '0x498232F0a52D4e94A6e0Ea93D63C07Bc63133009';

// https://explorer.zksync.io/address/0x1B242BEfc3008E8590Fc7aca27C74592CdEce6e3
export const AAVE_Network_Emergency_Count_ZKSync = '0x1B242BEfc3008E8590Fc7aca27C74592CdEce6e3';

export const CHAIN_ID = 324;
